import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { db } from "@/lib/data";
import { PageHeader } from "@/components/shared/Primitives";
export const Route = createFileRoute("/portal")({ component: Page });
function Page() {
  const { user } = useAuth(),
    [o, setO] = useState([]),
    [t, setT] = useState([]);
  useEffect(() => {
    if (user)
      Promise.all([
        db.orders({ customerId: user.id }),
        db.tickets({ customerId: user.id }),
      ]).then(([a, b]) => {
        setO(a);
        setT(b);
      });
  }, [user]);
  return (
    <div className="space-y-6">
      <PageHeader
        title={`Welcome, ${user?.name || "Customer"}`}
        description="Your KIZAK account and service hub."
      />
      <div className="grid gap-3 md:grid-cols-4">
        <Link
          to="/portal/orders"
          className="rounded-2xl border border-border bg-card p-5"
        >
          Orders <b className="block text-2xl">{o.length}</b>
        </Link>
        <Link
          to="/portal/tickets"
          className="rounded-2xl border border-border bg-card p-5"
        >
          Tickets <b className="block text-2xl">{t.length}</b>
        </Link>
        <Link
          to="/portal/addresses"
          className="rounded-2xl border border-border bg-card p-5"
        >
          Addresses
        </Link>
        <Link
          to="/shop"
          className="rounded-2xl border border-border bg-card p-5"
        >
          Shop
        </Link>
      </div>
    </div>
  );
}
